import { ReactElement, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { PlacesType } from 'react-tooltip';
import MagnifyingGlass from '../../../../components/svg/MagnifyingGlass';
import { g as abilityGlossary } from '../../../../config/ability';
import { checkPermission } from '../../../../dux';
import { State, Thunk } from '../../../../dux/@types';
import featureFlags, { FrontendFeature } from '../../../../featureFlags';
import GateTooltip from '../../../Shared/Tooltips/TooltipGate';
import NavSidebarSection from '../NavSidebarSection';
import { SidebarProps } from './SidebarProps';

const sidebarEventKey = 'SIDEBAR_SEARCH';

const SearchSidebarSection = (props: SidebarProps): ReactElement => {
  const { onNavClick } = props;

  const organizationUser = useSelector(
    (state: State) => state.account.organizationUser,
  );
  const dispatch = useDispatch();
  const [tooltipPlacement, setTooltipPlacement] = useState<PlacesType>('right');

  const canViewRegulations = featureFlags.isFeatureEnabledForUser(
    FrontendFeature.RegulationsSearch,
    organizationUser,
  );

  useEffect(() => {
    const handleResize = (): void => {
      const newPlace = window.innerWidth <= 768 ? 'top' : 'right';
      setTooltipPlacement(newPlace as PlacesType);
    };
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const canViewSection = (): Thunk<boolean> => {
    return dispatch(
      checkPermission(abilityGlossary.VIEW, abilityGlossary.SIDEBAR_SEARCH, true),
    );
  };

  if (!canViewRegulations) {
    return (
      <span id={sidebarEventKey}>
        <div className={`card ${!canViewSection() ? 'disabled' : ''}`}>
          <NavLink
            activeClassName="active-nav-link"
            className="card-header d-flex flex-row"
            onClick={onNavClick}
            to="/legislative-tracking"
          >
            <span className="sidebar-icon">
              <MagnifyingGlass height="18" width="18" />
            </span>
            <h2 className="title">Search</h2>
          </NavLink>
        </div>
        {!canViewSection() && (
          <GateTooltip
            accountType="pro"
            anchorId={sidebarEventKey}
            place={tooltipPlacement}
          />
        )}
      </span>
    );
  }

  const getCardBody = (): ReactElement => {
    return (
      <div>
        <NavLink
          activeClassName="active-nav-link"
          onClick={onNavClick}
          to="/legislative-tracking"
        >
          <h4 className="sub-item">Bills</h4>
        </NavLink>
        <NavLink
          activeClassName="active-nav-link"
          onClick={onNavClick}
          to="/regulations"
        >
          <h4 className="sub-item">Regulations</h4>
        </NavLink>
      </div>
    );
  };

  return (
    <NavSidebarSection
      cardBody={getCardBody()}
      eventKey="SEARCH"
      header="Search"
      icon={<MagnifyingGlass height="18" width="18" />}
    />
  );
};

export default SearchSidebarSection;
